export default {
    catalogs: (state) => state.catalogs
}